// frontend/src/navbar.js
import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaPhone, FaDollarSign, FaBook, FaSignInAlt, FaSignOutAlt, FaTh } from 'react-icons/fa';
import ThemeToggle from './components/ThemeToggle';
import './navbar.css';

function NavigationBar({ user, onLogout }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar-premium ${scrolled ? 'scrolled' : ''}`}>
      <Container className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <div className="logo-icon-wrapper">
            <span className="logo-icon">U</span>
          </div>
          <div className="logo-text-wrapper">
            <h1>UrbanQ</h1>
            <p className="logo-tagline">Smart living</p>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <ul className="nav-links desktop-only">
          <li>
            <Link to="/" className="nav-link">
              <FaHome className="nav-icon" />
              <span>Inicio</span>
            </Link>
          </li>
          <li>
            <Link to="/contactos" className="nav-link">
              <FaPhone className="nav-icon" />
              <span>Contactos</span>
            </Link>
          </li>
          <li>
            <Link to="/planes" className="nav-link">
              <FaDollarSign className="nav-icon" />
              <span>Precios</span>
            </Link>
          </li>
          <li>
            <Link to="/recursos" className="nav-link">
              <FaBook className="nav-icon" />
              <span>Recursos</span>
            </Link>
          </li>
        </ul>

        {/* Auth Buttons Desktop */}
        <div className="auth-buttons desktop-only">
          {!user ? (
            <>
              <Link to="/login" className="btn-login">
                <FaSignInAlt className="btn-icon" />
                <span>Ingreso</span>
              </Link>
              <Link to="/register" className="btn-primary">
                Comenzar
              </Link>
            </>
          ) : (
            <>
              {/* Dashboard para Admin y User */}
              <Link to="/dashboard" className="btn-dashboard">
                <FaTh className="btn-icon" />
                <span>Dashboard</span>
              </Link>
              {/* Botón de cambio de tema */}
              <div className="navbar-theme-toggle">
                <ThemeToggle />
              </div>
              <button onClick={onLogout} className="btn-logout">
                <FaSignOutAlt className="btn-icon" />
                <span>Salir</span>
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-toggle mobile-only" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </Container>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <Container>
          <ul className="mobile-nav-links">
            <li>
              <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>
                <FaHome className="nav-icon" />
                <span>Inicio</span>
              </Link>
            </li>
            <li>
              <Link to="/contactos" className="mobile-nav-link" onClick={toggleMobileMenu}>
                <FaPhone className="nav-icon" />
                <span>Contactos</span>
              </Link>
            </li>
            <li>
              <Link to="/planes" className="mobile-nav-link" onClick={toggleMobileMenu}>
                <FaDollarSign className="nav-icon" />
                <span>Precios</span>
              </Link>
            </li>
            <li>
              <Link to="/recursos" className="mobile-nav-link" onClick={toggleMobileMenu}>
                <FaBook className="nav-icon" />
                <span>Recursos</span>
              </Link>
            </li>
            {!user && (
              <li>
                <Link to="/login" className="mobile-nav-link" onClick={toggleMobileMenu}>
                  <FaSignInAlt className="nav-icon" />
                  <span>Ingreso</span>
                </Link>
              </li>
            )}
            {/* Dashboard para Admin y User */}
            {user && (
              <li>
                <Link to="/dashboard" className="btn-primary mobile-btn" onClick={toggleMobileMenu}>
                  <FaTh className="btn-icon" />
                  Dashboard
                </Link>
              </li>
            )}
            {/* Botón de tema en móvil */}
            {user && (
              <li className="mobile-theme-toggle">
                <ThemeToggle />
                <span>Cambiar tema</span>
              </li>
            )}
            {user && (
              <li>
                <button onClick={() => { onLogout(); toggleMobileMenu(); }} className="btn-logout mobile-btn">
                  <FaSignOutAlt className="btn-icon" />
                  Salir
                </button>
              </li>
            )}
          </ul>
        </Container>
      </div>
    </nav>
  );
}

export default NavigationBar;